export function formatMinutesAsHours(minutes: number): string {
    const sign = minutes < 0 ? "-" : "";
    minutes = Math.abs(minutes);
    const hours = Math.trunc(minutes / 60);
    const mins = (minutes % 60).toString().padStart(2, "0");

    return `${sign}${hours}:${mins}`;
}
